(function () {
  const STORAGE_KEY = 'freeShippingCaRegion';

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    } catch (_e) {
      return (cents / 100).toFixed(2);
    }
  }

  async function resolveCaRegion(useGeo) {
    if (!useGeo) return 'OTHER';
    const cached = sessionStorage.getItem(STORAGE_KEY);
    if (cached === 'ON' || cached === 'OTHER') return cached;
    try {
      const res = await fetch('https://ipapi.co/json/', { credentials: 'omit' });
      if (!res.ok) throw new Error('geo');
      const data = await res.json();
      if (data.country_code === 'CA' && data.region_code === 'ON') {
        sessionStorage.setItem(STORAGE_KEY, 'ON');
        return 'ON';
      }
      sessionStorage.setItem(STORAGE_KEY, 'OTHER');
      return 'OTHER';
    } catch (_e) {
      sessionStorage.setItem(STORAGE_KEY, 'OTHER');
      return 'OTHER';
    }
  }

  function pickThresholdCents(cfg, caRegion) {
    const country = (cfg.country || '').toUpperCase();
    if (country === 'US') return cfg.thresholdUs;
    if (country === 'CA') {
      return caRegion === 'ON' ? cfg.thresholdOn : cfg.thresholdRestCa;
    }
    return cfg.thresholdRestCa;
  }

  async function refreshElement(el) {
    const cfg = {
      thresholdOn: parseInt(el.dataset.thresholdOn, 10) || 0,
      thresholdRestCa: parseInt(el.dataset.thresholdRestCa, 10) || 0,
      thresholdUs: parseInt(el.dataset.thresholdUs, 10) || 0,
      useGeo: el.dataset.useGeo === 'true',
      country: el.dataset.country || '',
      messageProgress: el.dataset.messageProgress || 'Add [amount] more for free shipping.',
      messageSuccess: el.dataset.messageSuccess || 'You qualify for free shipping!',
    };

    const label = el.querySelector('[data-free-shipping-label]');
    const fill = el.querySelector('[data-free-shipping-fill]');

    try {
      const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
      const total = cart.total_price;
      const currency = cart.currency || 'USD';

      const caRegion =
        cfg.country.toUpperCase() === 'CA' ? await resolveCaRegion(cfg.useGeo) : 'OTHER';
      const threshold = pickThresholdCents(cfg, caRegion);

      if (threshold <= 0) {
        el.hidden = true;
        if (label) label.textContent = '';
        return;
      }

      el.hidden = false;
      const remaining = Math.max(0, threshold - total);
      const qualified = total >= threshold;
      const pct = Math.min(100, (total / threshold) * 100);

      if (fill) {
        fill.style.width = `${pct}%`;
      }

      if (label) {
        label.textContent = qualified
          ? cfg.messageSuccess
          : cfg.messageProgress.replace('[amount]', formatMoney(remaining, currency));
      }
    } catch (_e) {
      if (label && !label.textContent.trim()) {
        el.hidden = true;
      }
    }
  }

  function refreshAll() {
    document.querySelectorAll('[data-free-shipping-root]').forEach((el) => {
      refreshElement(el);
    });
  }

  document.addEventListener('DOMContentLoaded', refreshAll);

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAll);
  }
})();
